export const trainingTimeoutOptions = [
    { value: 3, label: '3 sekundy' },
    { value: 5, label: '5 sekund' },
    { value: 10, label: '10 sekund' },
];
